import React from 'react';
import { GROUP_ORDER } from '../../constants';

const GroupedSelect = ({ register, errors, defaultValue }) => (
    <div className="addSelect">
        <select
            {...register('group', { required: 'Group is required' })}
            defaultValue={defaultValue}
        >
            {GROUP_ORDER.map(group => (
                <option key={group} value={group}>{group}</option>
            ))}
        </select>
        {errors?.group && <span className="field-error">{errors.group.message}</span>}
    </div>
);

export default GroupedSelect;